import { inject, provideEnvironmentInitializer } from '@angular/core';
import { ReleaseService } from '@scheduler-frontend/release';

export function provideIonicInitialization() {
  return [
    provideEnvironmentInitializer(() => {
      const releaseService = inject(ReleaseService);

      void releaseService.openWhatsNewModalOnNewRelease();
    }),
  ];
}
